const firebaseConfig = {
    apiKey: "AIzaSyDbayAhIVL7FnirvMDc1YfJ7xXXswjkt_w",
    authDomain: "emporio-f3ee3.firebaseapp.com",
    databaseURL: "https://emporio-f3ee3-default-rtdb.firebaseio.com",
    projectId: "emporio-f3ee3",
    storageBucket: "emporio-f3ee3.appspot.com",
    messagingSenderId: "14436239634",
    appId: "1:14436239634:web:581bce5c8f29e1a1218bcb"
};

export default firebaseConfig;